export class ToastServiceMockSpec {
    open() {}
}
